export const COUNTRY_LEVEL_CUISINE_FRAGMENT = `
fragment cuisineDetails on Cuisine {
  cuisineName
  cuisineSlug
  title
  description
  image
  pageTitle
  metaDescription
}`;

export const CITY_LEVEL_CUISINE_FRAGMENT = `
fragment cuisineDetails on Cuisine {
  cuisineName
  cuisineSlug
  cityName
  title
  description
  image
  pageTitle
  metaDescription
}`;

export const RESTAURANT_REVIEWS_FRAGMENT = `
fragment restaurantReviews on RestaurantReviews {
  restaurant {
    id
    name
    image
    url
    city
    averageRating
    numRatings
  },
  reviews {
    rating
    reviewerName
    reviewDate
    content
  },
}`;

export const RECOMMENDED_CUISINES_FRAGMENT = `
fragment recommendedCuisines on RecommendedCuisine {
  title
  url
  description
  image
}`;

export const CUISINE_NEIGHBORHOODS_FRAGMENT = `
fragment cuisineNeighborhoods on Neighborhood {
  slug
  displayName
}`;

export const CUISINE_CITIES_FRAGMENT = `
fragment cuisineCities on City {
  slug
  displayName
}`;

export const CUISINE_ALTERNATE_LOCALE_FRAGMENT = `
fragment cuisineAlternateLocale on AlternateLocaleCuisine {
  locale
  cuisineSlug
  citySlug
}`;
